import React from "react";
import { ThinTextField } from "../../../common/GeneralComponent";

const GeneralInformation = ({ data }) => {

  const boq = data?.boqProposedDetails || {};
  const user = data?.implementationDetails?.created_by_user || {};
  const implementationDetails = data?.implementationDetails || {};

  const latitude = boq?.latitude || "";
  const longitude = boq?.longitude || "";

  // Format date and time from created_at
  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    
    // Format date as: DD/MM/YYYY
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    // Format time as: HH:MM AM/PM
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedHours = String(hours).padStart(2, '0');
    
    return `${day}/${month}/${year} ${formattedHours}:${minutes} ${ampm}`;
  };

  const dateOfVisit = formatDateTime(implementationDetails?.created_at);

  const visitorName = user?.name || "N/A";
  const designation = user?.role_name || "N/A";
  const organization = user?.organization || "N/A";
  const partnerName = user?.partner_organization_name || "N/A";

  const districtOptions = boq?.proposedDistrict?.district_name || "";
  const tehsilOptions = boq?.proposedTehsil?.tehsil_name || "";
  const ucOptions = boq?.proposedUcs?.uc_name || "";
  const dehOptions = boq?.proposedDeh?.deh_name || "";
  const villageOptions = boq?.proposedVillage?.village_name || "";

  return (
    <>
      {data ? (
        <div className="bg-white rounded p-4">
          <form className="w-full">
            {/* First Row - Location Info */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <ThinTextField
                isRequired={false}
                label="Latitude"
                value={latitude}
                disabled
              />
              <ThinTextField
                isRequired={false}
                label="Longitude"
                value={longitude}
                disabled
              />
              <ThinTextField
                isRequired={false}
                label="Date of Visit"
                value={dateOfVisit}
                disabled
              />
            </div>

            {/* Second Row - Visitor Info */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <ThinTextField
                isRequired={false}
                label="Name of Visitors"
                value={visitorName}
                disabled
              />
              <ThinTextField
                isRequired={false}
                label="Designation"
                value={designation}
                disabled
              />
              <ThinTextField
                isRequired={false}
                label="Organization"
                value={organization}
                disabled
              />
            </div>

            {/* Third Row - Partner and Administrative Locations */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <ThinTextField
                isRequired={false}
                label="Name of Partner"
                value={partnerName}
                disabled
              />
              <ThinTextField
                isRequired={false}
                label="District"
                value={districtOptions}
                disabled
              />
              <ThinTextField
                isRequired={false}
                label="Tehsil"
                value={tehsilOptions}
                disabled
              />
            </div>

            {/* Fourth Row - More Administrative Locations */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <ThinTextField
                isRequired={false}
                label="UC"
                value={ucOptions}
                disabled
              />
              <ThinTextField
                isRequired={false}
                label="Deh"
                value={dehOptions}
                disabled
              />
              <ThinTextField
                isRequired={false}
                label="Village"
                value={villageOptions}
                disabled
              />
            </div>
          </form>
        </div>
      ) : (
        <h2 className="text-center my-6 text-md text-gray-600">
          Data not found
        </h2>
      )}
    </>
  );
};

export default GeneralInformation;